import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyBBYO1Rpj71v_CiZW1nmPfsKqULdM32IUc",
  authDomain: "www.tutrend.in",
  databaseURL: "https://edufriend-website.firebaseio.com",
  projectId: "edufriend-website",
  storageBucket: "edufriend-website.appspot.com",
  messagingSenderId: "784374724758",
  appId: "1:784374724758:web:93edfaef95d142b061eab7",
  measurementId: "G-W5R5Y127XT",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics();

const appAuth = firebase.auth();
const authObject = firebase.auth;
const appStorage = firebase.storage();
const appFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;
//for providing google oauth

export { appAuth, authObject, appStorage, appFirestore, timestamp };
